import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function Picture({
  image,
  defaultTransform,
  alt = undefined,
  loading,
  fetchPriority = undefined,
  imgClass,
}) {
  const media = {
    xs: '(max-width: 358px)',
    sm: '(max-width: 767px)',
    'md-min': '(min-width: 768px)',
    md: '(max-width: 991px)',
    'lg-min': '(min-width: 992px)',
    lg: '(max-width: 1199px)',
    'xl-min': '(min-width: 1200px)',
    xl: '(max-width: 1439px)',
    '4k': '(min-width: 3840px)',
    xxl: '(min-width: 1920px)',
  };

  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current && typeof fetchPriority === 'string' && fetchPriority.length > 0) {
      imgRef.current.setAttribute('fetchPriority', fetchPriority);
    }
  }, [fetchPriority]);

  return (
    image && (
      <picture>
        {Object.entries(media).map(([key, value]) => (
          (image.transforms[key]) && (
            <source
              media={value}
              srcSet={image.transforms[key]?.url}
              key={key}
              width={image.transforms[key]?.width}
              height={image.transforms[key]?.height}
            />
          )
        ))}
        <img
          ref={imgRef}
          src={image.transforms[defaultTransform]?.url}
          alt={alt || image.alt || image.title || ''}
          loading={loading}
          width={image.transforms[defaultTransform]?.width}
          height={image.transforms[defaultTransform]?.height}
          className={imgClass || null}
        />
      </picture>
    )
  );
}

Picture.propTypes = {
  image: PropTypes.object,
  defaultTransform: PropTypes.string,
  alt: PropTypes.string || null,
  loading: PropTypes.string,
  imgClass: PropTypes.string,
  fetchPriority: PropTypes.string || null,
};

export { Picture };
